let $ = jQuery;
let breakpoints = require('../utilities/breakpoints');
let helpers = require('../utilities/helpers');
// Import Greensock and it's plugins.
let CSSPlugin = require('../../node_modules/gsap/src/uncompressed/plugins/CSSPlugin');
let EasePack = require('../../node_modules/gsap/src/uncompressed/easing/EasePack');
let TweenLite = require('../../node_modules/gsap/src/uncompressed/TweenLite');

class EmbedVideo {

  constructor($video) {
    this.$videoBtn = $video;
    this.$parent = this.$videoBtn.parents('.media-embed__content-wrapper');
    this.$video = this.$parent.find('iframe');
    this.$video.attr('tabindex', '-1');
    // We set this to 0 to insure that when a user hits the back button our video doesn't autoplay.
    this.$video[0].src += '&autoplay=0';
    this.$videoBtn.off('click.embedVideo').on('click.embedVideo', () => this.handleClick());
  }

  handleClick() {

    window.TweenLite.to(this.$videoBtn, .25, {
      opacity: 0,
      onComplete: () => {
        this.$video[0].src = helpers.updateQueryStringParameter(this.$video[0].src, 'autoplay', '1');
        this.$video.attr('tabindex', '0');
        this.$video.focus();
        this.$videoBtn.remove();
        this.$parent.addClass('overlay-hidden');
      }
    });

    return false;
  }
}

module.exports = {

  attach: function(context, settings) {
    let $videos = $('.js-embed-video');
    let videoArray = [];

    $videos.each( (i) => {
      let $video = $videos.eq(i);
      videoArray.push(new EmbedVideo($video));
    });
  }
};
